import SvgDrop from '@/assets/ic-drop';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
    { title: 'English', symbol: 'en', emoji: '🇬🇧' },
    { title: 'Spanish', symbol: 'es', emoji: '🇪🇸' },
    { title: 'Malay', symbol: 'ms', emoji: '🇲🇾' },
    { title: 'Swahili', symbol: 'sw', emoji: '🌍' },
    { title: 'Portuguese', symbol: 'pt', emoji: '🇧🇷' },
    { title: 'Hindi', symbol: 'hi', emoji: '🇮🇳' },
    { title: 'Indonesian', symbol: 'id', emoji: '🇮🇩' },
    // { title: 'Thai', symbol: 'th', emoji: '🇹🇭' },
    { title: 'Filipino', symbol: 'fi', emoji: '🇵🇭' },
    { title: 'Korean', symbol: 'ko', emoji: '🇰🇷' },
    { title: 'Japanese', symbol: 'ja', emoji: '🇯🇵' },
];
export function Language() {
    const [isOpen, setIsOpen] = useState(false);
    const { i18n } = useTranslation();
    const containerRef = useRef<HTMLDivElement>(null);

    const language = languages.find((item) => item.symbol === i18n.language);

    useEffect(() => {
        if (!containerRef.current || !isOpen) {
            return;
        }

        function clickOutside(e: MouseEvent) {
            if (!containerRef.current?.contains(e.target as Node)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('click', clickOutside);

        return () => {
            document.removeEventListener('click', clickOutside);
        };
    }, [isOpen]);

    return (
        <div className="relative" ref={containerRef}>
            <button
                data-action="select-language"
                onClick={() => {
                    setIsOpen((v) => !v);
                }}
                className="flex items-center justify-center gap-1 border border-[#1C1C1C] rounded-[10px] px-2 py-[5px] min-w-16"
            >
                <p className="text-white font-medium text-sm leading-5 pl-1 flex gap-x-1 items-center uppercase">
                    <span className="pt-[2px]">{language?.emoji ?? '🇬🇧'}</span>
                    <span>{language?.symbol ?? 'EN'}</span>
                </p>
                <SvgDrop className="rotate-180" />
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ type: 'spring', duration: 0.5 }}
                        className="absolute right-0 top-10 z-[100] bg-black rounded-[10px] border border-[#1C1C1C]"
                    >
                        <ul className="p-1 flex flex-col gap-1">
                            {languages.map((item, index) => {
                                return (
                                    <li
                                        data-action={`language-${item.symbol}`}
                                        onClick={() => {
                                            setIsOpen(false);
                                            localStorage.setItem(
                                                'language',
                                                item.symbol
                                            );
                                            i18n.changeLanguage(item.symbol);
                                        }}
                                        key={index}
                                        className={clsx(
                                            'cursor-pointer flex items-center justify-between px-2 py-0.5 min-w-14 text-center rounded-md ',
                                            {
                                                'bg-[#1C1C1C]':
                                                    i18n.language ===
                                                    item.symbol,
                                            }
                                        )}
                                    >
                                        <p
                                            className={clsx(
                                                'text-sm leading-5 text-primary text-white opacity-20 text-left w-full flex gap-x-1 items-center',
                                                {
                                                    'opacity-100!':
                                                        i18n.language ===
                                                        item.symbol,
                                                }
                                            )}
                                        >
                                            <span className="pt-1">
                                                {item.emoji}
                                            </span>
                                            <span>{item.title}</span>
                                        </p>
                                    </li>
                                );
                            })}
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
